import axios from "axios";
import { MSA_TOKEN } from "@/constants";
import Cookies from "js-cookie";

const axiosInstance = () => {
  const token: any = Cookies.get(MSA_TOKEN);

  //setting the environment
  let url: any = "";

  if (process.env.NEXT_PUBLIC_NODE_ENV === "local") {
    url = process.env.NEXT_PUBLIC_BACKEND_LOCAL_BASE_URL;
  } else if (process.env.NEXT_PUBLIC_NODE_ENV === "development") {
    url = process.env.NEXT_PUBLIC_BACKEND_DEVELOPMENT_BASE_URL;
  } else if (process.env.NEXT_PUBLIC_NODE_ENV === "staging") {
    url = process.env.NEXT_PUBLIC_BACKEND_STAGING_BASE_URL;
  } else if (process.env.NEXT_PUBLIC_NODE_ENV === "production") {
    url = process.env.NEXT_PUBLIC_BACKEND_PRODUCTION_BASE_URL;
  }

  const environment = url ? `${url}/api/v1` : "/api/v1";

  // Create axios instance
  const instance = axios.create({
    baseURL: environment,
    headers: {
      authorization: token ? `Bearer ${token}` : null,
    },
  });

  return instance;
};

export default axiosInstance;
